import CONSTANTS from '../../Constants'
import { useAppDispatch, useAppSelector } from '../../Store/Hooks'
import { setLoader } from '../../Store/Slice/loader.slice'
import { updateNotificationsReadStatus } from '../../Store/Slice/notifications.slice'
import { MUIButton } from '../Shared'
import styles from './Notification.module.scss'

const MarkAllRead = () => {
  const dispatch = useAppDispatch()
  const { unreadCount } = useAppSelector((state) => state.notifications)

  const handleMarkAllAsRead = async () => {
    dispatch(setLoader(true))
    await dispatch(
      updateNotificationsReadStatus({
        apiPayload: { isReadAll: true, notificationIds: [], isRead: true },
        showLoader: false,
      }) as any,
    )
    dispatch(setLoader(false))
  }

  return (
    <MUIButton
      className={styles.markAllAsReadButton}
      size='small'
      type='button'
      label={CONSTANTS.MARK_ALL_AS_READ}
      handleClickCB={handleMarkAllAsRead}
      disabled={unreadCount < 1}
    />
  )
}

export default MarkAllRead
